import { timetableBeta } from "@/api";
import { setTimetableData, setTimetableDataLoading, setTimetableDataError } from "./timetableSlice";
import { typesEnum } from '@pages/Main/Timetable/components/Types/typesEnum';
import store from "@store/redux.store";
import rolesEnum from "@/constant/rolesEnum";

export const fetchTimetableData = ({addMe, typeAll} = {}) => async (dispatch, getState) => {
  dispatch(setTimetableDataLoading(true))
  const { filters, weekRange, day, type } = getState().timetable;
  const isOneDay = type === typesEnum.oneDay;
  const finalFilters = store.getState()?.profile?.profile?.role === rolesEnum.seminarian ? {
    ...filters,
    seminarians: [store.getState()?.profile?.profile?.id]
  } 
  : 
  {
    ...filters,
    seminarians: !!filters?.direction ? 
                 filters?.seminariansInCourses : 
                 addMe ? [...filters?.seminarians, store.getState()?.profile?.profile?.id] : filters?.seminarians
  };
  if(store.getState()?.profile?.profile?.role === rolesEnum.parent) {
    if(!store.getState()?.parentSelectedChildId) return;
    finalFilters.childrens = [store.getState()?.parentSelectedChildId];
  }
  
  try {
    const api = isOneDay ? timetableBeta.getDailyTimetableDataСancel : timetableBeta.getWeeklyTimetableDataСancel;
    const params = { 
        filters: finalFilters,
        ...(isOneDay ? {day} : weekRange),
        type: typeAll ? typesEnum.all : type
    }
    const response = await api(params);

    dispatch(setTimetableData(response.data.data));
    dispatch(setTimetableDataError(null))
  } catch (error) {
    dispatch(setTimetableDataError(error))
  } finally {
    dispatch(setTimetableDataLoading(false))
  }
};